<template>
  <main>
    <b-modal id="applicationFormModal" size="lg" scrollable centered title="Let us know where you shine, send us your resume!">
      <template v-if="thankYou">
        <h3 class="text-center tall-bottom-padding">Thank you for your submission!</h3>
      </template>
      <template v-else>
        <div id="apply_form" class="form-default">
          <div class="row">
            <div class="form-group col-md-6">
              <label for="first_name">First Name <span>Required field</span></label>
              <input v-model="form.firstName" type="text" class="form-control" id="first_name" name="first_name" placeholder="First Name" value="" required="">
              <div v-if="errors.firstName" class="error">The field is required</div>
            </div>
            <div class="form-group col-md-6">
              <label for="last_name">Last Name <span>Required field</span></label>
              <input v-model="form.lastName" type="text" class="form-control" id="last_name" name="last_name" placeholder="Last Name" value="" required="">
              <div v-if="errors.lastName" class="error">The field is required</div>
            </div>
          </div>
          <div class="form-group">
            <label for="email">E-mail <span>Required field</span></label>
            <input v-model="form.email" type="email" class="form-control" id="email" name="email" placeholder="E-mail" value="" required="">
            <div v-if="errors.email" class="error">The field is required</div>
          </div>
          <div class="form-group">
            <label for="phone">Phone<span>Required field</span></label>
            <input v-model="form.phone" type="tel" class="form-control" id="phone" name="phone" placeholder="Phone" value="" required="">
            <div v-if="errors.phone" class="error">The field is required</div>
          </div>
          <div class="form-group">
            <label for="desired_position">Desired Position<span>Required field</span></label>
            <input v-model="form.position" type="text" class="form-control" id="desired_position" name="desired_position" placeholder="Desired Position" value="" required="">
            <div v-if="errors.position" class="error">The field is required</div>
          </div>
          <div class="form-group">
            <label for="resume">Please attach your résumé (.doc, .docx, or .pdf).<span>Required field</span></label>
            <input type="file" ref="resume" class="form-control-file" id="resume" name="resume" required="" @change="handleFileUpload">
          </div>
          <div class="form-group">
            <label for="cover_letter">Please attach your cover letter (.doc, .docx, or .pdf).<span>Required field</span></label>
            <input type="file" ref="letter" class="form-control-file" id="cover_letter" name="cover_letter" required="" @change="handleFileUploadLetter">
          </div>
        </div>
      </template>
      <template #modal-footer>
        <b-btn variant="secondary" @click="$bvModal.hide('applicationFormModal')" v-if="!thankYou">Cancel</b-btn>
        <b-btn variant="primary" @click="sendEmail" v-if="!thankYou">Submit Application</b-btn>
      </template>
    </b-modal>
    <background-wrapper src="careers/fullscreen-image_hero" ext="png">
      <b-row class="hero">
        <b-col cols="12" md="6" lg="6" sm="11" class="top-z-index">
          <div class="hero__content">
            <h1 v-html="$t(`Careers.header.title`)"/>
            <b-btn class="mt-2" variant="primary" v-scroll-to="{ el: '#current-positions', offset: -70 }">
              {{$t(`Careers.header.btn`)}}
            </b-btn>
          </div>
        </b-col>
        <b-col cols="12" md="6" lg="6" align-self="end">
          <div class="hero-image">
            <img class="d-none d-sm-block" :src="require(`@/assets/${$toKebabCase($route.name)}/hero.png`)" :alt="$t(`img.${$route.name}.hero`)">
            <img class="d-block d-sm-none" :src="require(`@/assets/${$toKebabCase($route.name)}/hero_xs.png`)" :alt="$t(`img.${$route.name}.hero`)">
            <b-button v-b-modal.modal-video class="home-video-button"/>
            <img :src="require(`@/assets/${$toKebabCase($route.name)}/hero-koza.png`)" :alt="$t(`img.${$route.name}.hero`)">
          </div>
        </b-col>
      </b-row>
      <b-modal id="modal-video" size="xl" centered hide-header hide-footer>
        <div style="padding:56.25% 0 0 0;position:relative;">
          <iframe
            id="hero_video"
            src="https://player.vimeo.com/video/377807059?badge=0&autopause=0&player_id=0&app_id=58479"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            allowfullscreen=""
            title="HRdownloads - Love What You Do"
            data-ready="true">
          </iframe>
        </div>
      </b-modal>
    </background-wrapper>
    <h1 class="feature-title">{{$t(`Careers.features.title`)}}</h1>
    <b-row class="features justify-content-center" tag="ul">
      <b-col v-for="n in 3" :key="n" cols="12" md="6" lg="4" tag="li">
        <div class="feature mb-4">
          <img class="mb-2" :src="require(`@/assets/careers/feature_${n}.png`)" width="100%">
          <h4 :class="['h1', bgColors[n]]">{{$t(`Careers.features.${n}.title`)}}</h4>
          <p v-html="$t(`Careers.features.${n}.text`)" />
        </div>
      </b-col>
    </b-row>
    <background-wrapper color="#EEF1F6" class="our-perks">
      <div class="content-with-image">
        <b-row align-v="center" class="justify-items-sm-center">
          <b-col class="text-column" lg="6" md="12" cols="12">
            <div class="our-perks__header">
              <h1 class="pb-2">{{$t(`Careers.perk.title`)}}</h1>
              <p class="h-sub pb-2" v-html="$t(`Careers.perk.list`)" />
            </div>
            <div class="list-wrapper">
              <img class="list d-none d-sm-block" :src="require(`@/assets/careers/list_${$i18n.locale}.svg`)">
              <img class="list d-sm-none" :src="require(`@/assets/careers/list-sm_${$i18n.locale}.svg`)" width="330px" style="max-widht: 100%; width: 330px;">
            </div>
            <b-row class="justify-content-between pt-3" align-v="center">
              <b-col cols="5" md="4" lg="5">
                <img src="@/assets/careers/living.png">
              </b-col>
              <b-col cols="7" md="8" lg="7">
                <img src="@/assets/careers/hr.svg" width="100%">
              </b-col>
            </b-row>
          </b-col>
          <b-col class="image-column d-none d-lg-block" lg="6" cols="12">
            <div class="image-column__wrapper">
              <img src="@/assets/careers/perk.png">
            </div>
          </b-col>
        </b-row>
      </div>
    </background-wrapper>
    <h1 class="feature-title mt-6 mb-2 mb-sm-4 mb-md-6">{{$t(`Careers.award`)}}</h1>
    <div class="slider-wrapper">
      <VueSlickCarousel :arrows="true" v-bind="settings_2">
        <div v-for="n in 12" :key="n">
          <div class="our-awards__image">
            <img :src="require(`@/assets/careers/slider/slide_${n}.png`)"/>
          </div>
        </div>
        <template #prevArrow>
          <div class="custom-arrow">
            <img src="@/assets/arrow-left.svg">
          </div>
        </template>
        <template #nextArrow>
          <div class="custom-arrow">
            <img src="@/assets/arrow-right.svg">
          </div>
        </template>
      </VueSlickCarousel>
    </div>
    <background-wrapper src="careers/response-bg" ext="png">
    <div class="response">
        <h1 class="feature-title">{{$t(`Careers.response.title`)}}</h1>
        <div class="response__slider">
          <VueSlickCarousel :arrows="true" v-bind="settings">
            <div class="mt-3" cols="12" md="6" lg="4" v-for="n in 7" :key="n">
              <div class="avatar bg-white m-2 p-3">
                <img class="projects-your-way__image" :src="require(`@/assets/careers/avatars/avatar_${n}.png`)"/>
                <h4 class="mt-2 mb-1">{{$t(`Careers.response.employees.${n}.name`)}}</h4>
                <h5 class="mb-3 position">{{$t(`Careers.response.employees.${n}.position`)}}</h5>
                <p class="mb-0">{{$t(`Careers.response.employees.${n}.text`)}}</p>
              </div>
            </div>
            <template #prevArrow>
              <div class="custom-arrow-fill">
                <img src="@/assets/arrow-left-fill.svg">
              </div>
            </template>
            <template #nextArrow>
              <div class="custom-arrow-fill">
                <img src="@/assets/arrow-right-fill.svg">
              </div>
            </template>
          </VueSlickCarousel>
        </div>
        <div class="content-with-image pt-4">
          <b-row align-v="center" class="justify-items-sm-center">
            <b-col class="text-column" md="6" cols="12">
              <h1 class="pb-2">{{$t(`Careers.response.content.title`)}}</h1>
              <p class="h-sub" v-html="$t(`Careers.response.content.text`)" />
            </b-col>
            <b-col class="image-column" offset-md="2" md="4" cols="12">
              <div class="avatar bg-white my-5 p-3">
                <img src="@/assets/careers/avatar.svg"/>
                <h4 class="mt-2 mb-1">{{$t(`Careers.response.content.name`)}}</h4>
                <h5 class="mb-3 position">{{$t(`Careers.response.content.position`)}}</h5>
                <p v-html="$t(`Careers.response.content.positionText`)" />
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </background-wrapper>
    <h1 class="feature-title" id="current-positions">{{$t(`Careers.current.currentPositions`)}}</h1>
    <b-row class="pb-2 text-uppercase font-weight-bold">
      <b-col cols="9" sm="6">{{$t(`Careers.current.title`)}}</b-col>
      <b-col cols="3" class="text-center">{{$t(`Careers.current.department`)}}</b-col>
      <b-col cols="3" class="d-none d-sm-block text-center">{{$t(`Careers.current.posted`)}}</b-col>
    </b-row>
    <b-row class="pb-2">
      <b-col cols="12">
        <div id="whr_embed_hook"></div>
      </b-col>
    </b-row>
    <background-wrapper src="careers/footer" ext="png">
      <div class="tell-us">
        <text-container :alignCenter="true">
          <h2 class="mt-6" v-html="$t(`Careers.footer.title`)"/>
          <p v-html="$t(`Careers.footer.text`)"/>
          <b-btn class="mt-2 mx-auto" variant="primary" v-b-modal.applicationFormModal>
            {{$t(`Careers.footer.btn`)}}
          </b-btn>
        </text-container>
      </div>
    </background-wrapper>
    <script type="application/ld+json">
      {
        "@context": "https://schema.org",
        "@type": "VideoObject",
        "name": "Life at HRdownloads",
        "description": "Together we are better. Checkout our current opportunities.",
        "thumbnailUrl": "https://hrdownloads.com/images/publicPages/careers/video/thumbnail/life_at_hrdownloads.png",
        "uploadDate": "2020-01-01T08:00:00-0500",
        "duration": "PT0M31S",
        "publisher": {
          "@type": "Organization",
          "name": "HRdownloads Inc.",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.hrdownloads.com/images/logos/logo-with-tagline.png",
            "width": 1920,
            "height": 1080
          }
        },
        "contentUrl": "https://player.vimeo.com/external/377804686.hd.mp4?s=44b47a0555fd6a510dac7dd8017e1917b9181bc4&profile_id=175",
        "embedUrl": "https://player.vimeo.com/video/377804686"
      }
    </script>
  </main>
</template>

<script>
import ContentWithImage from '@/components/ui/ContentWithImage.vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import axios from 'axios'

export default {
  name: 'Careers',
  components: {
    ContentWithImage,
    VueSlickCarousel
  },
  mounted () {
    const script = document.createElement('script')
    script.src = 'https://www.workable.com/assets/embed.js'
    document.body.appendChild(script)
    script.addEventListener('load', () => {
      if (window.whr_embed) {
        window.whr_embed(3960, {detail: 'titles', base: 'jobs', zoom: 'country', grouping: 'none'})
      }
    })
  },
  computed: {
    isFormValid () {
      return !Object.keys(this.errors).some(k => this.errors[k])
    }
  },
  methods: {
    validEmail (email) {
      const re = /(.+)@(.+){2,}\.(.+){2,}/
      return re.test(email.toLowerCase())
    },
    handleFileUploadLetter () {
      this.file2 = this.$refs.letter.files[0]
    },
    handleFileUpload () {
      this.file = this.$refs.resume.files[0]
    },
    showThankYou () {
      this.thankYou = true
    },
    validate () {
      this.errors.firstName = this.form.firstName.length === 0
      this.errors.lastName = this.form.lastName.length === 0
      this.errors.phone = this.form.phone.length === 0
      this.errors.email = !this.validEmail(this.form.email)
      this.errors.position = this.form.position.length === 0
    },
    sendEmail () {
      this.validate()
      if (this.isFormValid) {
        const emailBody = `
          First Name - ${this.form.firstName} \n
          Last Name - ${this.form.lastName} \n
          E-mail - ${this.form.email} \n
          Phone - ${this.form.phone} \n
          Desired Position - ${this.form.position} \n
        `
        let data = new FormData()
        data.append('from', process.env['EMAIL_FROM'])
        data.append('to', process.env['CAREERS_FORM_ADDRESS'])
        data.append('subject', 'HRDownloads.com Careers Form Submission')
        data.append('body', emailBody)
        if (this.file) data.append('attachment', this.file)
        if (this.file2) data.append('attachment', this.file2)

        axios.post(`${process.env['CMS_DOMAIN']}/api/contact`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(() => {
            this.showThankYou()
          })
          .catch(err => console.log(err))
      }
    }
  },
  data () {
    return {
      file: '',
      file2: '',
      thankYou: false,
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        position: ''
      },
      errors: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        position: ''
      },
      bgColors: {
        1: 'bg-blue',
        2: 'bg-purple',
        3: 'bg-yellow'
      },
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      },
      settings_2: {
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      }
    }
  }
}
</script>

<style lang="sass">
.top-z-index
  z-index: 2
.error
  color: red
.our-perks
  .background-wrapper
    &__image
      +media-breakpoint-up(lg)
        display: none!important
    &__content
      +media-breakpoint-down(md)
        padding: 65px 0!important

#whr_embed_hook
  .whr-items
    margin-top: 5px
    list-style: none
    margin-left: 0
    padding-left: 0
    .whr-item *
      font-size: 14px
      font-weight: 900
      letter-spacing: 0.6px
      color: #666b75
      text-transform: uppercase
      +media-breakpoint-down(xs)
        font-size: 12px
    .whr-item
      margin-top: 30px
      clear: both
      &::after
        content: ''
        clear: both
        display: block
      .whr-title
        width: 49%
        display: inline-block
        margin-bottom: 0
        +media-breakpoint-down(xs)
          width: 70%
      .whr-info
        width: 50%
        float: right
        display: inline-block
        list-style: none
        margin-left: 0
        padding-left: 0
        text-align: center
        +media-breakpoint-down(xs)
          width: 25%
        .whr-location
          display: none
        .whr-dept
          width: 50%
          display: inline-block
          float: left
          +media-breakpoint-down(xs)
            width: 100%
          span
            display: none
        .whr-date
          width: 46%
          float: right
          display: inline-block
          +media-breakpoint-down(xs)
            display: none
          span
            display: none
</style>

<style lang="sass" scoped>
img
  max-width: 100%

.hero
  padding: 53px 0 0
  @media screen and (min-width: 2000px)
    // calc((100vw - 2000px)/4 ~ 0-40px
    padding-top: calc((100vw - 2000px)/6 + 53px)
  +media-breakpoint-down(lg)
    padding: 180px 0 0
  +media-breakpoint-down(md)
    padding: 180px 0 0
  +media-breakpoint-down(sm)
    padding: 20px 0 0
    a
      margin-bottom: 50px

  &__content
    padding-top: 230px
    padding-left: 150px
    @media screen and (min-width: 2000px)
      padding-top: calc(230px - (100vw - 2000px)/6)
      padding-left: calc(150px - (100vw - 2000px)/6)
    +media-breakpoint-down(lg)
      padding-top: 100px
      padding-left: 40px
    +media-breakpoint-down(md)
      padding-top: 40px
      padding-left: 20px
    +media-breakpoint-down(sm)
      padding-left: 30px
      margin-bottom: -15px
    +media-breakpoint-down(xs)
      margin-bottom: 10px
    +media-breakpoint-down(xxs)
      padding-left: 0

.hero-image
  margin-right: -19%
  margin-left: -63%
  position: relative
  pointer-events: none
  @media screen and (min-width: 2000px)
    margin-right: -19%
    margin-left: -63%
  +media-breakpoint-down(lg)
    margin-right: -26%
    margin-left: -56%
  +media-breakpoint-down(md)
    margin-right: -30%
    margin-left: -50%
  +media-breakpoint-down(sm)
    margin-left: -10%
    margin-right: -20%
  +media-breakpoint-down(xs)
    margin-left: -40%
    margin-right: -15%
  +media-breakpoint-down(xxs)
    margin-left: -50%
    margin-right: -20%

  &:before
    content: ''
    display: block
    padding-top: 69.052044609%
    width: 100%

  img
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    object-fit: contain

.home-video-button
  display: block
  width: 36.2%
  height: 40.3%
  position: absolute
  top: 18.5%
  left: 35.9%
  transform: rotate(-16.4deg) skew(0.1deg, 1.8deg)
  border-radius: 9.4%
  border-color: transparent
  background: transparent
  background: rgba(black, .3)
  pointer-events: auto

  &:hover
    background: rgba($primary, .3)

.feature-title
  text-align: center
  padding: 4rem 0 2rem

.features
  margin-top: 50px
  margin-bottom: 120px
  padding: 0
  text-align: center
  list-style: none
  .feature
    display: flex
    flex-direction: column
    align-items: center
    margin: auto
    max-width: 400px
    h4
      padding: 0 10px
      &.bg-yellow
        background: #FFE451
      &.bg-purple
        background: #CDBCF6
      &.bg-blue
        background: #7FC8FF

.slider-wrapper
  padding: 0 40px
  +media-breakpoint-down(xxs)
    padding: 0 0px

.custom-arrow
  color: $dark
  font-size: 14px
  height: 29px
  &:before
    content: none

.custom-arrow-fill
  height: 75px
  width: 75px
  +media-breakpoint-down(xxs)
    height: 50px
    width: 50px
  &:before
    content: none

  &.slick-prev
    left: -80px
    z-index: 9999
    +media-breakpoint-down(xxs)
      left: -40px

  &.slick-next
    right: -80px
    +media-breakpoint-down(xxs)
      right: -40px

.our-awards
  &__image
    display: flex
    align-items: center
    justify-content: center
    padding: 0 20px
    height: 140px
    width: 100%

    img
      max-height: 100%
      width: auto
      max-width: 100%

.avatar
  margin-top: 130px !important
  min-height: 300px
  .position
    color: #666B75
  img
    display: block
    margin: -130px auto auto
    max-width: 180px
    max-height: 180px

.response
  padding: 100px 0 250px
  +media-breakpoint-down(sm)
    padding: 60px 0 120px
  +media-breakpoint-down(xs)
    padding: 20px 0 120px

  .feature-title
    margin-bottom: 0

  .text-column
    +media-breakpoint-down(sm)
      margin: auto
      max-width: 520px
      text-align: center
      justify-content: center

  .image-column
    &__wrapper
      +media-breakpoint-down(lg)
        margin: auto!important
    img
      max-width: 100%
      width: 100%
    +media-breakpoint-down(sm)
      display: none

  &__slider
    padding: 0 $spacer * 3
    +media-breakpoint-down(sm)
      margin-bottom: 50px
    +media-breakpoint-down(xxs)
      padding: 0 $spacer

.text-light-color
  color: #666B75
.center
  text-align: center
.our-perks
  &__header
    +media-breakpoint-down(sm)
      text-align: center
    +media-breakpoint-down(xs)
      margin: auto
      max-width: 350px

.list-wrapper
  margin: -1% -2%
  +media-breakpoint-down(xs)
    display: flex
    justify-content: center

.list
  max-width: 100%
  width: 100%

.slick-prev
  +media-breakpoint-down(xxs)
    left: -5px
    z-index: 9999

.slick-next
  +media-breakpoint-down(xxs)
    right: -10px

.tell-us
  padding: 0 0 280px
  +media-breakpoint-down(lg)
    padding: 0 0 150px
  +media-breakpoint-down(md)
    padding: 0 0 100px
  +media-breakpoint-down(sm)
    padding: 0 0 150px
  +media-breakpoint-down(xs)
    padding: 0 0 60px
</style>



// WEBPACK FOOTER //
// src/components/careers/Careers.vue